import { useRef, useEffect, MutableRefObject } from 'react';
import axios, { CancelTokenSource } from 'axios';

interface UseCancelTokenReturn {
  getCancelTokenSource: () => CancelTokenSource;
  cancel: (message?: string) => void;
  getCurrentSource: () => CancelTokenSource | null;
}

export const useCancelToken = (): UseCancelTokenReturn => {
  const cancelTokenSourceRef: MutableRefObject<CancelTokenSource | null> = useRef<CancelTokenSource | null>(null);

  const getCancelTokenSource = (): CancelTokenSource => {
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel();
    }
    cancelTokenSourceRef.current = axios.CancelToken.source();
    return cancelTokenSourceRef.current;
  };

  const cancel = (message?: string): void => {
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel(message);
      cancelTokenSourceRef.current = null;
    }
  };

  const getCurrentSource = (): CancelTokenSource | null => {
    return cancelTokenSourceRef.current;
  };

  useEffect(() => {
    return () => {
      cancel('Компонент размонтирован');
    };
  }, []);

  return { getCancelTokenSource, cancel, getCurrentSource };
};